import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api-client";

export interface ITranslationStatus {
  enabled: boolean;
  targets: string[];
  expectedTargets: number;
  perPage: Record<
    string,
    { ready: number; pending: number; failed: number; stale: number }
  >;
  summary: {
    totalPages: number;
    expected: number;
    ready: number;
    pending: number;
    failed: number;
    stale: number;
  };
  failed: Array<{
    pageId: string;
    slugId: string;
    title: string | null;
    publicSlug: string | null;
    language: string;
    error: string | null;
  }>;
  stale: Array<{
    pageId: string;
    slugId: string;
    title: string | null;
    publicSlug: string | null;
    language: string;
  }>;
}

async function fetchSpaceStatus(spaceId: string): Promise<ITranslationStatus> {
  const res = await api.post<ITranslationStatus>("/translations/space-status", {
    spaceId,
  });
  return res.data;
}

export function useTranslationStatus(spaceId?: string) {
  return useQuery({
    queryKey: ["translation-status", spaceId],
    queryFn: () => fetchSpaceStatus(spaceId as string),
    enabled: !!spaceId,
    // Workers translate in seconds; refetch periodically so the dot &
    // summary tick toward "all ready" without a manual reload.
    refetchInterval: (query) => {
      const data = query.state.data as ITranslationStatus | undefined;
      if (!data || !data.enabled) return false;
      // Stop polling once everything is ready or only failed left.
      if (data.summary.pending === 0) return false;
      return 5000;
    },
    staleTime: 3000,
  });
}
